import { render, staticRenderFns } from "./mcoreword.vue?vue&type=template&id=cb05a3c0&scoped=true&"
import script from "./mcoreword.vue?vue&type=script&lang=js&"
export * from "./mcoreword.vue?vue&type=script&lang=js&"
import style0 from "./mcoreword.vue?vue&type=style&index=0&id=cb05a3c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb05a3c0",
  null
  
)

export default component.exports